const EventData = [
  // {
  //   id: 1,
  //   name: "Aqua-Innovate",
  //   link: "AquaMOD",
  //   poster: "/img/event/AquaInnovate.png",
  //   description:
  //     "Aqua-Innovate is an event that gives an unique opportunity to showcase your skills in a real-life setting. It challenges participants to unleash their creativity and critical thinking by modifying a vessel in a way that improves its efficiency in terms of both usage and cost. By participating in this event, you'll have the chance to create something that boosts your problem-solving abilities.",
  //   teamSize: "1",
  //   maxTeamSize: 1,
  //   fee: "₹100",
  //   fees: 100,
  //   prize: "₹3000",
  //   date: "21st March 2025",
  //   brochure: "",
  //   submission: "",
  //   rulestab: [
  //     {
  //       tabId: "1",
  //       heading: "Stages and Timeline",
  //       data: [
  //         "Stages and Timeline Aqua-Innovate has two rounds First submit an abstract If chosen present and answer questions in the next round",

  //         " Stage1 Model and Document Submission To participate in Aqua-Innovate follow these steps",

  //         " 1 Create a CAD model General Arrangement GA and a fitting documentation explaining your idea",
  //         "2 Organise these files in a Google Drive folder named Your_Name_Aqua-Innovate",
  //         "3 Email the folder to samudramanthaniitkgp2024@gmail.com",
  //         "4 Make sure the files are named as follows Your_Name_Aqua-Innovate_CAD Your_Name_Aqua-Innovate_GA and Your_Name_Aqua-Innovate_Documentation",
  //         "5 Include a short 100-150 word description in the email",
  //         "6 Any form of deception leads to disqualification",

  //         "Stage2 Offline Presentation To showcase your idea",

  //         "- Present to judges highlighting why your creation is top-notch and its real-life impact on vessels",
  //         "- Location Seminar room in the department",
  //         "- Presentation 15 minutes",
  //         "- Q&A 5 minutes",
  //         "- Submit on the second day of the event",
  //       ],
  //     },
  //     {
  //       tabId: "2",
  //       heading: "Rules and Regulations",
  //       data: [
  //         "- Teams can have up to 3 members from different places.",
  //         "- Rules and updates are on the Samudra-Manthan website.",
  //         "- Technical issues aren't their responsibility.",
  //         "- Don't copy. Cheating gets you kicked out.",
  //         "- Organisers make final calls in disputes for everyone's benefit.",
  //       ],
  //     },
  //     {
  //       tabId: "3",
  //       heading: "Evaluation Criteria",
  //       data: [
  //         "The winners will be selected from the participants with the closest answer Solutions of only the participants with the correct solution/logic will be considered ",
  //       ],
  //     },
  //     {
  //       tabId: "4",
  //       heading: "Prizes",
  //       data: [
  //         "- All teams get participation certificates from Samudra-Manthan IIT Kharagpur.",
  //         "- Outstanding designs may be featured on their social media.",
  //         "- Top 3 teams win cash prizes totaling Rs. 25,000:",
  //         "- 1st Place: Rs. 10,000",
  //         "- 2nd Place: Rs. 8,000",
  //         "- 3rd Place: Rs. 7,000.",
  //       ],
  //     },
  //   ],
  // },

  {
    id: 2,
    name: "Deep Sea Disputes",
    link: "Dispustes",
    poster: "/img/event/DeepSeaDispustes.png",
    description:
      "Deep Sea Disputes invites participants on a captivating journey to explore the depths of their understanding and surface with compelling arguments that navigate the uncharted waters of contemporary challenges in Ocean Engineering and Naval Architecture. Competitors will engage in three dynamic rounds, each meticulously designed to test their knowledge, critical thinking, and ability to articulate and defend their perspectives. Prepare to Dive Deep into the ocean of knowledge, where only the most insightful and articulate debaters will rise to victory!",
    teamSize: "3-4",
    maxTeamSize: 4,
    fee: "₹160",
    fees: 160,
    prize: "₹18000",
    date: "coming soon",
    brochure:
      "https://drive.google.com/file/d/1Q5waQpcMu6Ov4Ee-gqKAV-pcJUHjAnvT/view",
    // submission: "",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          "Round 1: Preliminary Debate",
          "•Each team will be allotted a topic and decide whether to speak for or against it. Teams will take notes on paper. If there’s a conflict of interest, a coin toss will decide their stance.",
          "•One team starts the debate by presenting their point.",
          "•The opposing team responds with a counterpoint.",
          "•This continues for 10 minutes.",
          "•Teams will be judged on the strength of their arguments, quick thinking, and overall speaking skills.",
          "•Participants will earn points based on their knowledge and debating skills, advancing to the next round through a points-based system.",
          "•Top 8 teams, according to their point, will proceed in Round 2.",
          "Round 2: Semi-Final Debate",
          "•The remaining 8 teams will debate in pairs, with topics assigned at the start. The format remains similar to Round 1 but with more complex and technical topics.",
          "•Judging criteria remain the same, but emphasis will also be placed on depth of knowledge and articulation.",
          "•Half the teams from the round will proceed to the final round.",
          "Round 3: Grand Finale",
          "•Two debates of the remaining 4 teams for the further debates of winner, runner-up, second runner-up position.",
          "•Two winning teams will debate for 1st position.",
          "•Two losing teams will compete for 3rd position.",
          "•The final round will have an extended debate time of 15 minutes.",
          "•Teams will be expected to present research-backed arguments and answer questions from judges.",
          "•The champions and runners-up will be decided based on a comprehensive evaluation.",
        ],
      },
      {
        tabId: "2",
        heading: "Rules and Regulations",
        data: [
          "•Each team will be allotted a topic and will decide on their stance.The debate will last 10 minutes, with each team having the opportunity to present their arguments and respond to the opposing team’s points. Judging Criteria: Strength of arguments, articulation, rebuttal skills, and overall speaking ability. The Top 8 teams will move on to the next round.",
          "•The remaining 8 teams will compete in pairs. The topics will be more complex and technical. The format will be similar to Round 1, but with more focus on the depth of knowledge and technical articulation. The Top 4 teams will proceed to the Grand Finale.",
          "•Two teams will compete for the 1st position and two other teams will compete for 3rd. Teams must be prepared to present research-backed arguments and answer questions. Final rankings will be based on comprehensive evaluation including argument quality, depth of knowledge, articulation, and interaction with judges.",
        ],
      },
      {
        tabId: "3",
        heading: "Evaluation Criteria",
        data: [
          "•Argument Strength (logical consistency, clarity, relevance).",
          "•Quick Thinking & Rebuttal Skills (ability to counter opposing points effectively).",
          "•Communication Skills (clarity, persuasion, structure of speech).",  
          "•Depth of Knowledge (evidence of thorough research and understanding of the topic).",
          "•Engagement with Judges (ability to answer and engage with questions and challenges).",
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "- All participants get participation certificates.",
          "- Top 3 in the Debate event win a total of ₹18,000.",
          "- 1st Prize: ₹9000",
          "- 2nd Prize: ₹6000",
          "- 3rd Prize: ₹3000",
          "- Winners receive e-certificates and social media recognition.",
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Maritime Mystery",
    link: "Treasurehunt",
    poster: "/img/event/CrypticClues.png",
    description:
      "Maritime Mystery, the Ultimate Treasure Hunt is an exciting event where participants navigate marine-themed puzzles, riddles, and word challenges to uncover hidden treasure. With time-penalized hints, it’s a test of wit, perseverance, and maritime knowledge!",
    fee: "₹120",
    teamSize: "1",
    maxTeamSize: 1,
    fees: 120,
    prize: "₹12000",
    date: "21st March 2025",
    brochure:
      "https://drive.google.com/file/d/1kaXaoGCARfREeaVtG9fCIglAzHT9dX95/view",
    // submission: "",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          "It will be played on an App more details will be provided soon",
          "Unlock clues for the final location upon solving the riddles",
          "Receive a hint for the next challenge upon completion",
          "Participants will get 10 minutes penalty which doubles for every subsequent wrong answer",
          
        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
          "1. Phones will be confiscated from all the participants before the start of the event",
          "2. Participants are strictly prohibited from communicating the clues to others during the event",
          "3. Any kind of misbehavior will lead to immediate disqualification",
          "4. All participants must follow the rules and play fairly",
          "5. Any participant found to be cheating, vandalizing, or disrupting the event in any way will be immediately disqualified",
        ],
      },
      {
        tabId: "3",
        heading: "Evaluation Criteria",
        data: [
          "The evaluation will be based on the following criteria:",
          "1. Creativity",
          "2. Originality",
          "The winner will be the first player to solve all the given cryptic clues cleverly in the given time.",
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹6000",
          "2nd Prize: ₹3600",
          "3rd Prize: ₹2400",
        ],
      },
    ],
  },      
  {
    id: 4,
    name: "Boat Wars",
    link: "Boatwars",
    poster: "/img/event/BoatWars.png",
    description:
      "Welcome to the Aquatic Mastery Challenge, an exciting event combining boat racing and tug of war. This competition tests your knowledge of ships and their practical applications. Your boat model will be evaluated for speed, stability, and handling. The event features three rounds: the Boat Racing Championship, where sleek vessels race through a demanding course, and the Tug of War Spectacle, where teams compete in a thrilling test of strength and strategy. Spectators cheer as the power and camaraderie of the participants shine through.",
    fee: "₹300",
    teamSize: "2-4",
    maxTeamSize: 4,
    fees: 300,
    prize: "₹30000",
    date: "coming soon",
    brochure: "https://drive.google.com/file/d/1FwOLeCtLOUnDrdkEIBdX9AUCwkjo6Gap/view",
    // submission: "",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          "Round 1: Maneuvering Test",
          "The Participants will have to complete the path provided in the maze in the shortest time possible",
          "The total score will be normalized based on the least and maximum time taken",
          "Round 2: Maneuvering test with checkpoints",
          "The participants must complete the path provided in the maze in the shortest time possible, along with crossing specific checkpoints",
          "Participants must make a smart choice between the crossing checkpoints and time",
          "The total score will be calculated based on both the time taken and the checkpoints crossed",
          "Round 3: Weight Tugging Challenge",
          "A floating platform with some weight would be tied to the rear end of the vessel",
          "Hooks will NOT be provided. The participants need to attach hooks to their vessel at a convenient location.",
          "Time taken to complete the maze path while tugging the boat will be considered for evaluation",
        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
          "General:",
          "Teams of 2-4 members, with a designated leader",
          "Only one boat model per team for all rounds",
          "No unfair practices or serious violations, or face disqualification",
          "Participants are requested to provide us with the dimensions and specs of their boats before participating in the competition",
          "Round 1 - 20 points",
          "Boat race on a challenging course, judged by time taken",
          "The fastest boat wins the highest point",
          "Round 2 - 40 points",
          "The path for this round will be complex, with added features",
          "Checkpoints will be placed along the path, and scores will be distributed accordingly",
          "Half of the points(20 points) will be awarded based on the time taken to cover the path",
          "The remaining half will be awarded for the checkpoints covered",
          "Round 3 - 40 points",
          "The weight to be tugged by all the boats is same(1kg)",
          "The winner of each pool gets the highest points",
          "Length of the rope between hook and the platform can be adjusted by the participants",
        ],
      },
      {
        tabId: "3",
        heading: "General Information",
        data: [
          "Dimensions of the vessel:",
          "Length: 30cm ± 5cm",
          "Breadth: 15cm ± 5cm",
          "Dimensions of the pool: 12 x 12 x 1 (in feet)/ 3.6 x 3.6 x 0.3 (in meters)"
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹15000",
          "2nd Prize: ₹9000",
          "3rd Prize: ₹6000",
        ],
      },
      {
        tabId: "5",
        heading: "Evaluation Criteria",
        data: [
          "Round 1:",
          "The Boat Race will be judged based solely on the time taken by each boat to complete the race",
          "The boat that finishes the race in the shortest time will be declared the winner, and the participant with the fastest overall time will claim the highest point",
          "Round 2:",
          "The path for this round will be the same as the previous round",
          "The checkpoints covered by the boat to complete the race will affect the points scored",
          "Round 3:",
          "The path for this round will be the same as the previous round",
          "The team with the fastest time will claim full points and other teams will get normalized score",
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Quizathon",
    link: "Quizathon",
    poster: "/img/event/Quizathon.png",
    description:
      "Quizathon is a distinctive general knowledge competition designed for quiz enthusiasts eager to participate. The event revolves around a question-and-answer format, targeting individuals passionate about expanding their knowledge of the ocean, naval architecture, and puzzle-solving. Beyond just being a fun event, it offers participants a unique opportunity for creative self-assessment and personal growth in a relaxed, enjoyable environment.",
    fee: "₹150",
    teamSize: "1-2",
    maxTeamSize: 2,
    fees: 150,
    prize: "₹12000",
    date: "coming soon",
    brochure: "https://drive.google.com/file/d/1PCKhM-BE44HtCR_W5SvsrNcZf-EDVi1E/view",
    // submission: "",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          `Quizathon will be organized in 3 stages, with top participants from each round progressing to the next. Stage 1 has two sub-rounds. At the end of stage 3, the final winner will be judged based on their performance and time.`, `Stage 1: Aqua Myths and Marine Facts - This round includes 15 statements, each of which participants have 15 minutes to evaluate. Within this time limit, they must decide whether each statement is a myth or a fact. Each correct answer earns +1 point, while an incorrect response results in a deduction of 0.25 points. Skipping a question doesn’t affect the score. Only one team member is required to participate in this round. Visual Identification - In this round, participants are shown images related to marine topics, such as historical ships, navigation tools, famous maritime sites, deep-sea species, geological formations, or underwater phenomena. Participants need to identify each image accurately. Each correct answer awards 1 point, while incorrect answers deduct 0.25 points. This round requires the involvement of other team members.`, `Stage 2: Word Riddle - This round resembles a crossword puzzle. Participants have 15 minutes to solve 8 crossword clues. Each correct answer awards +2 points, while an incorrect answer results in a deduction of 0.5 points. Skipping a clue does not affect the score. Both team members are allowed to participate in this round.`, `Stage 3: Rapid Fire Round - In this stage, each team is presented with 7 questions consecutively and has 5 minutes to answer them. If a team is unsure of an answer, they can say "pass" to move to the next question. Each correct response is awarded 5 points, with no penalty for incorrect answers. After this round, scores from all stages will be combined to determine the overall winner.`
        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
         `This is a team event with each team consisting of 2 members.`, `In Stage 1, only one team member can participate in each sub-round.`, `Both team members can participate together in Stages 2 and 3.`, `The top 5 teams will proceed to Stage 3.`, `Malpractice is strictly prohibited:`, `Any participant caught engaging in unfair practices will be disqualified from the event.`, `Serious violations may lead to disqualification from Samudra Manthan 2024.`, `The judges’ decisions are final and binding for all participants and teams.`
        ],
      },
      {
        tabId: "3",
        heading: "Judging Criteria",
        data: [
          `Judging Criteria for Stage 1: Each correct answer earns +1 point. Each incorrect answer results in a deduction of 0.25 points. No points are awarded or deducted for unattempted questions. The scores from both sub-rounds will be combined. The top 70% of participants, based on points, will qualify for the next round.`, `Judging Criteria for Stage 2 (Word Riddle): Each correct answer earns +2 points. Each incorrect answer results in a deduction of 0.5 points. No points are awarded or deducted for unattempted questions.`, `Eligibility for Stage 3: Scores from Stage 1 and Stage 2 will be added. The top 5 teams, based on combined scores, will qualify for Stage 3.`, `Judging Criteria for Stage 3 (Rapid Fire Round): Teams are judged based on the number of correct answers given within 5 minutes. 25% of the score from Stage 2 will be added to the final score. The final score is calculated as 75% of the Stage 3 score and 25% of the Stage 2 score. The team with the highest final score will be declared the winner at the end of this round.`
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹6000",
          "2nd Prize: ₹3600",
          "3rd Prize: ₹2400",
        ],
      },
    ],
  },
  {
    id: 6,
    name: "Aquaexposure",
    link: "Aquaexposure",
    poster: "/img/event/AquaExposure.png",
    teamSize: "1",
    description:
      "This competition challenges participants to explore the ocean’s many dimensions through a photo story, using 7 to 10 images to craft a compelling visual narrative. Whether capturing its breathtaking beauty, immense power, or ecological significance, each image should contribute to a story that resonates.",
    fee: "₹100",
    prize: "₹6000",
    date: "coming soon",
    brochure: "https://drive.google.com/file/d/1kVjAi7TbkTqr0xAY6uCRkyRgeJVQt4wo/view",
    // submission: "https://forms.gle/NUcFo85YWectMsXN8",
    // fees: 100,
    maxTeamSize: 1,
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
         `This is a single-stage competition.`, `The participants have to submit their photographs using the Google form.`, `The form will be mailed to the participants a week before the deadline.`, `Participants must upload their photographs to their Instagram account.`, `Each participant can submit a maximum of 7 photographs.`, `The images must be realistic. AI-generated photos are prohibited from using.`,
        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
          `The contest is open to individuals of all ages and backgrounds.`, `Participants must have a public Instagram and Facebook account to enter the contest.`, `Photos that have been previously submitted to other contests or plagiarized images are not allowed.`, `Hashtags and Tagging: Participants must include the official event hashtag, such as Samudramanthan2025storylellingContest, in the caption of their photo.`, `Additionally, participants should tag the official Instagram account.`, `(#Samudramanthan2025 AND #AquaExposure) in the caption itself.`, `Avoid heavy editing or manipulation that distorts the original subject matter.`, `The images should not be imaginary or AI-generated and must be realistic and relevant to the theme.`, `The story should be no longer than 900 words.`,
        ],
      },
      {
        tabId: "3",
        heading: "Evaluation Criteria",
        data: [
          `Creativity and Originality – 25%`, `Relevance to the Theme – 25%`, `Storytelling and Structure – 20%`, `Visual Impact and Integration – 20%`, `Grammar, Language, and Clarity – 10%`,
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹3000",
          "2nd Prize: ₹2000",
          "3rd Prize: ₹1000",
        ],
      },
    ],
  },
  {
    id: 7,
    name: "Wave Quest",
    link: "Wavequest",
    poster: "/img/event/WaveQuest.png",
    description:
      "Wave Quest is an engaging event that challenges participants to address real-world problems in ocean engineering. This competition, designed to ignite the spark of ingenuity, is set to catalyze collaboration, amplify critical thinking, and hone the problem-solving process. ",
    fee: "₹180",
    prize: "₹18000",
    teamSize: "1-4",
    date: "22nd March 2025",
    fees: 180,
    maxTeamSize: 4,
    brochure: "https://drive.google.com/file/d/1eZ0ed2nGr5wgGLUFrJRbKddpQfmcEGo3/view",
    submission: "https://docs.google.com/forms/d/e/1FAIpQLSehobsfccHPmI8NNXfiampXlS8kL0VSiLoo_WcPsbpk7yfdaQ/viewform",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          `Round 1: Case Study Assignment and Research`, `Participants will have to come up with a solution for the given problem statement.`, `Teams will conduct thorough research, analyze the problem, and develop solutions.`, `Each team will submit their solution presentation within the specified deadline.`, `Round 2: Presentations and Q&A`, `Each team will present their solution to the judging panel.`, `The judges will evaluate the presentations and engage in a question-and-answer session with each team.`, `Teams will be scored based on the evaluation criteria.`, `The presentation will last a maximum of 10 minutes, and 5 minutes will be kept for the judge's Q&A session.`,

        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
          `Eligibility: The competition is open to individuals or teams of participants with a background or interest in ocean engineering or related fields.`, `Team Size: Each team can consist of 1 to 4 members.`, `Selection: Participants need to come up with an abstract submitted in Round 1.`, `The abstract should include your concept of solution, economic feasibility, and any reference you have taken from somewhere else.`, `Each team will be assigned one case study to analyze and develop solutions for.`, `Time: The presentation should be completed within 10 minutes. On exceeding, there will be a penalty.`, `Research and Analysis: Participants must conduct thorough research, analyze the given problem statement, and develop innovative and feasible solutions.`, `Presentation Format: Teams will present their solutions in a structured PowerPoint or PDF presentation, adhering to a specified time limit.`, `Language: Presentations and supporting materials should be submitted in English.`,
        ],
      },
      {
        tabId: "3",
        heading: "Judging Criteria",
        data: [
          `Round 1:`, `Argument Strength (logical consistency, clarity, relevance). [50%]`, `Presentation structure and information provided. [30%]`, `Adhering to the deadline for submission in the specified format. [20%]`, `Round 2:`, `Innovation in solution development [30%]`, `Depth of knowledge and understanding of the concepts used in the solution [20%]`, `Evaluation of the team's technical competence and approach [30%]`, `Quality of answer given to the judge’s question and adhering to the time limit [20%]`,
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹9000",
          "2nd Prize: ₹6000",
          "3rd Prize: ₹3000",
        ],
      },
    ],
  },
  {
    id: 8,
    name: "Paper Prep",
    link: "PaperPrep",
    poster: "/img/event/paperprep.png",
    description:
      `We are thrilled to announce Paper Prep, an event that invites participants to delve
into cutting-edge challenges in ocean-related fields and present their innovative
solutions. This competition challenges participants to think critically, explore new
possibilities, and create impactful research.`,
    fee: "₹180",
    teamSize: "1-4",
    prize: "₹18000",
    date: "23rd March 2025",
    brochure: "https://drive.google.com/file/d/1S8OsUgvtWn1faw-rhaHYK8WTOR7MWXmN/view",
    fees: 180,
    maxTeamSize: 4,
    submission: "https://forms.gle/HSVXNnxzfZQypfKa9",
    rulestab: [
      {
        tabId: "1",
        heading: "Stages and Timeline",
        data: [
          `This competition will consist of two stages: `,`

Stage 1: Abstract Submission

Details: Participants must submit an abstract summarizing their
research on a chosen topic.
Requirements: The abstract must be concise and clearly outline
the research topic, methodology, expected outcomes, and
innovations it brings to the field.
Deadline for Submission: To be announced.
Submission Method: Abstracts should be submitted as a single
PDF file via the provided Google Form. The form will be sent to
the team leader.`,`
Stage 2: Presentation and Q&A

Details: Teams selected from Stage 1 will be invited to present
their research to a panel of judges. The presentation will be
followed by a 5-minute Q&A session.
Duration: The presentation should be no longer than 10 minutes,
with an additional 5 minutes for Q&A.
Announcement of Stage 2 Details: Teams selected for Stage 2 will
be informed and provided with all necessary information.`,
        ],
      },
      {
        tabId: "2",
        heading: "Rules And Regulations",
        data: [
          `Team Formation: Teams may consist of up to 4 members.
Members can be from different universities or organizations.`,`
Team Leader: A team leader must be designated to handle
communication and coordination.`,`
Plagiarism: Any form of plagiarism is strictly prohibited. Teams
found indulging in unfair practices will be disqualified
immediately.`,`
Citation: All external data and research must be appropriately
cited.`,`

Stage 1 (Abstract Submission):

Abstract Length: The abstract must be 1-3 pages long, submitted
as a single PDF file.
Submission Method: The abstract should be submitted via a
Google Form, which will be sent only to the team leader. The
form must include the abstract in PDF format.`,`
Stage 2 (Presentation):

All team members must participate actively in the presentation
and Q&A session.
Presentations must adhere to the 10-minute time limit, with an
additional 5 minutes for Q&A.
The decision of the judges is final and binding on all teams.`,
        ],
      },
      {
        tabId: "3",
        heading: "Evaluation Criteria",
        data: [
          `Stage 1: Abstract Evaluation (100 marks total)`,`

Adherence to rules: 10%`,`
Originality of research: 20%`,`
Clarity and quality of abstract presentation: 20%`,`
Feasibility and application of the research idea: 30%`,`
Uniqueness and innovativeness of the abstract: 20%`,`


Stage 2: Presentation Evaluation (100 marks total)`,`

Originality and creativity: 30%`,`
Organization and logical flow of ideas: 15%`,`
Delivery and presentation style: 10%`,`
Knowledge and depth of subject: 20%`,`
Response to Q&A session: 20%`,`
Team participation (all members involved): 5%`,
        ],
      },
      {
        tabId: "4",
        heading: "Prizes",
        data: [
          "The top 3 winners will be awarded cash prizes and certificates.",
          "1st Prize: ₹9000",
          "2nd Prize: ₹6000",
          "3rd Prize: ₹3000",
        ],
      },
    ],
  },
];

export default EventData;
